var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 36C23.178 36 16 28.822 16 20C16 11.178 23.178 4 32 4C40.822 4 48 11.178 48 20C48 28.822 40.822 36 32 36ZM32 8C25.382 8 20 13.382 20 20C20 26.618 25.382 32 32 32C38.618 32 44 26.618 44 20C44 13.382 38.618 8 32 8Z",
    fill: "#0C4654"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46 60H18C12.486 60 8 55.514 8 50C8 44.486 12.486 40 18 40H46C51.514 40 56 44.486 56 50C56 55.514 51.514 60 46 60ZM18 44C14.692 44 12 46.692 12 50C12 53.308 14.692 56 18 56H46C49.308 56 52 53.308 52 50C52 46.692 49.308 44 46 44H18Z",
    fill: "#0C4654"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.178a9de9b163fc3a41aea91a2afb08f8.svg";
export { ForwardRef as ReactComponent };